import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-[72vh] flex-col items-center justify-center px-6 text-center">
      <div
        data-testid="payment-cancel"
        className="flex max-w-md flex-col items-center rounded-3xl border border-[#D9A441]/20 bg-[#131422]/70 p-10"
      >
        <XCircle className="h-10 w-10 text-[#A3A5B8]" />
        <h1 className="mt-6 font-display text-2xl text-[#F8F3E6]">Checkout cancelled</h1>
        <p className="mt-3 text-sm text-[#A3A5B8]">
          No charge was made. You can upgrade whenever you're ready.
        </p>
        <button
          onClick={() => navigate("/")}
          data-testid="cancel-back-home-btn"
          className="mt-8 rounded-full border border-[#D9A441]/50 bg-[#D9A441]/10 px-6 py-3 text-sm font-medium text-[#E5C365] transition-all hover:bg-[#D9A441]/20"
        >
          Back to The Cardlight
        </button>
      </div>
    </div>
  );
}
